module.exports = __webpack_public_path__ + "1eeafa605137b5d22d67069edfb875cc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg56.jpeg
// module id = 68
// module chunks = 0